module.exports = __webpack_public_path__ + "img/center front upper pocket position.8ef90505.png";